import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ProductUnitsActions} from '../store';
import {ProductUnitsSelectors} from '../store/selectors';

@Injectable()
export class ProductUnitsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadProductUnitsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadProductUnitsDone(): Observable<boolean> {

    return this.store.pipe(
      select(ProductUnitsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ProductUnitsActions.ReadProductUnits());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
